export default __webpack_public_path__ + "static/media/guideTraining.44cae7c6.png";